import { render, staticRenderFns } from "./invoicetype-form.vue?vue&type=template&id=46b0681c&"
import script from "./invoicetype-form.vue?vue&type=script&lang=ts&"
export * from "./invoicetype-form.vue?vue&type=script&lang=ts&"
import style0 from "./invoicetype-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports